import * as React from "react"
import styled from "styled-components"
import { Formik, Form, FormikActions, FormikProps } from "formik"
import * as Yup from "yup"
import { History } from "history"
import "antd/lib/message/style/css"
import { compose } from "react-apollo"
import { Subscribe } from "unstated"
import message from "antd/lib/message"

import Loader from "src/dashboards/components/loader"
import AuthenticationState from "src/hoc/authentication/authentication.state"
import { loginRequest } from "src/hoc/authentication/lock"
import {
  FetchSingleListingUnits,
  UserType,
  CreateBookingVariables,
  CreateBookingHOC
} from "src/generated/graphql"
import Colors from "src/theme/colors"
import Column from "../column"
import Row from "../row"
import Text from "../text"
import Select from "../select"
import Button from "../button"
import "./date-picker.css"

const Wrapper = styled(Column as any)`
  padding: 16px;
  border-radius: 5.5px;
  box-shadow: 0 2px 15px 0 rgba(60, 66, 64, 0.05), 0 2px 15px 0 rgba(60, 66, 64, 0.1);
  background-color: #ffffff;
  box-sizing: border-box;
`

const HelpSection = styled(Column as any)`
  width: 100%;
  min-height: 112px;
  border-radius: 4px;
  margin-top: 16px;
  padding: 16px 16px 24px 16px;
  background-color: ${Colors.primaryWithOpacity};
`

const ContactLink = styled.a`
  color: ${Colors.primary};
  font-weight: 600;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`
interface MyFormValues {
  unit: string
  // moveInDate: null | Moment
  // leaseDuration: string
}

interface CreateBookingInput {
  variables: CreateBookingVariables
}

const BookingWidgetValidationSchema = Yup.object().shape({
  unit: Yup.string().required("Required")
  // moveInDate: Yup.date().required("Required"),
  // leaseDuration: Yup.string().required("Required")
})

interface State {
  booking: any
  isLoadind: boolean
}

type Props = {
  units: null | Array<FetchSingleListingUnits>
  listingID: string
  history: History
  match: {
    params: {
      id: string
    }
  }
  createBooking(input: CreateBookingInput): () => {}
}

const errorMessage = (msg: string) => {
  message.error(msg)
}

class BookingWidget extends React.PureComponent<Props, State> {
  state = {
    booking: null,
    isLoadind: false
  }

  render() {
    const { units, listingID, history } = this.props
    const { isLoadind } = this.state

    const unitAvailable = units && units.filter(item => item.available)
    const unitOptions =
      unitAvailable &&
      unitAvailable.reduce((result: Array<{ value: string; label: string }>, unit: any) => {
        return [
          ...result,
          {
            value: unit.title,
            label: unit.title
          }
        ]
      }, [])

    return (
      <Wrapper>
        <Subscribe to={[AuthenticationState]}>
          {(authState: AuthenticationState) => {
            return (
              <>
                <Loader loader={isLoadind} />
                <Formik
                  initialValues={{
                    unit: ""
                  }}
                  validationSchema={BookingWidgetValidationSchema}
                  onSubmit={async (values: MyFormValues, formikAction: FormikActions<any>) => {
                    /**
                     * Create initial booking here
                     */
                    // await this.props.updateUser({ variables: values })
                    if (authState && authState.state && !authState.state.user) {
                      loginRequest(true, false, authState)
                      return
                    }
                    try {
                      this.setState({ isLoadind: true })
                      const booking = await this.props.createBooking({
                        variables: {
                          data: {
                            unit: values.unit,
                            introduction: "",
                            Listing: {
                              connect: {
                                id: listingID
                              }
                            }
                          }
                        }
                      })
                      this.setState({ isLoadind: false })
                      this.setState({ booking })
                      if (
                        authState &&
                        authState.state &&
                        authState.state.user &&
                        authState.state.user.userType === UserType.Admin
                      ) {
                        history.push("/adminInbox")
                      } else {
                        history.push("/message")
                      }
                    } catch (error) {
                      this.setState({ isLoadind: false })
                      if (error.message === "GraphQL error: BOOKING_ALREADY_EXISTS") {
                        // pass through.
                        this.setState({ booking: true }, () =>
                          errorMessage(
                            "You have already sent an inquiry about this listing, check your messages."
                          )
                        )
                        return
                      }
                      /* eslint-disable no-console */
                      console.log(error.message)
                      /* eslint-enable no-console */
                      errorMessage("Unexpected error creating the booking")
                    }

                    // history.push({
                    //   pathname: `/listing/${listingID}/contact`,
                    //   search: qs.stringify({
                    //     ...prevSearchQuery,
                    //     unit: values.unit,
                    //     // leaseDuration: values.leaseDuration,
                    //     // moveInDate: (values.moveInDate && values.moveInDate.toISOString()) || ""
                    //   })
                    // })
                  }}
                >
                  {({ values, errors, setFieldValue, isValid }: FormikProps<MyFormValues>) => {
                    return (
                      <Form>
                        <Text color={Colors.darkGrey} fontSize={18} mb="8px">
                          Unit interested in
                        </Text>
                        {unitOptions && (
                          <Select
                            options={unitOptions}
                            name="unit"
                            placeholder="Unit"
                            onChange={(e: any) => {
                              setFieldValue("unit", e.value)
                            }}
                          />
                        )}
                        <Row my="16px" justifyContent="space-between">
                          <Column width={["50%", "50%", "50%"]} pr={[2, 2, 2]}>
                            {/* <Text color={Colors.darkGrey} fontSize={18} mb="8px">
                            Move in
                          </Text> */}
                            {/* <SingleDatePicker
                            id="moveInDatePicker"
                            onDateChange={(date: Moment | null) => {
                              if (date) {
                                setFieldValue("moveInDate", date)
                              }
                            }}
                            date={values.moveInDate}
                          /> */}
                          </Column>
                          <Column width={["50%", "50%", "50%"]}>
                            {/* <Text color={Colors.darkGrey} fontSize={18} mb="8px">
                            Lease term
                          </Text>
                          <StyledSelect
                            options={durationOptions}
                            placeholder="Duration"
                            onChange={(e: any) => {
                              setFieldValue("leaseDuration", e.value)
                            }}
                            initialValue=""
                            name="leaseDuration"
                          /> */}
                          </Column>
                        </Row>
                        {authState.state.user &&
                          authState.state.user.userType === UserType.Unverified ? (
                          <Button href="/signup-modal" link={true}>
                            🔐 Please verify your profile
                          </Button>
                        ) : (
                          <Button disabled={!isValid} type="submit">
                            Send Inquiry
                          </Button>
                        )}
                        <HelpSection>
                          <Text fontSize={20} fontWeight={600} color={Colors.primary} mb="1px">
                            Need Help?
                          </Text>
                          <Text fontSize={18} color={Colors.primary}>
                            Our team can assist you with the listing you want.{" "}
                            <ContactLink
                              rel="canonical"
                              href="https://www.tolobi.com/contact-us"
                              target="_blank"
                            >
                              Contact Us
                            </ContactLink>
                          </Text>
                        </HelpSection>
                      </Form>
                    )
                  }}
                </Formik>
              </>
            )
          }}
        </Subscribe>
      </Wrapper>
    )
  }
}

// export default BookingWidget

export default compose(
  CreateBookingHOC({
    props: ({ mutate }: any) => ({
      createBooking: (input: CreateBookingInput) => mutate(input)
    })
  })
)(BookingWidget)
